import { flexRender, type Cell } from "@tanstack/react-table";
import { Skeleton } from "../Skeleton";
import { getBodyCellProps } from "./utils/getBodyCellProps";

interface TableCellProps<TData> {
  cell: Cell<TData, unknown>;
  loading?: boolean;
}

export function TableCell<TData>({ cell, loading }: TableCellProps<TData>) {
  const content = flexRender(cell.column.columnDef.cell, cell.getContext());
  const body = loading ? <Skeleton>{content}</Skeleton> : content;
  const { style, className, innerStyle, innerClassName } = getBodyCellProps(
    cell.column,
  );

  return (
    <td style={style} className={className}>
      {innerStyle || innerClassName ? (
        <div style={innerStyle} className={innerClassName}>
          {body}
        </div>
      ) : (
        body
      )}
    </td>
  );
}
